import { CustomiseOffersOptionProps } from './CustomiseOffersOptionProps';

export const CustomiseOffersOptions: CustomiseOffersOptionProps[] = [
  {
    id: 1,
    title: 'Increase transaction limit',
    subCopy: (
      <>
        Encourage higher average order value.
        <br />
        Available for <strong>Zip Money</strong> and <strong>Zip Plus</strong>
      </>
    ),
    selected: false,
    details: {
      label: 'Add product and new limit*',
      text: '',
    },
    requiredErrorMessage: 'Product and new limit details are required',
  },
  {
    id: 2,
    title: 'Update interest free offers',
    subCopy: (
      <>
        Drive more sales with interest free offers.
        <br />
        Available for <strong>Zip Money</strong> only.
      </>
    ),
    selected: false,
    details: {
      label: 'Add offer details*',
      text: '',
    },
    requiredErrorMessage: 'Offer details are required',
  },
  {
    id: 3,
    title: 'Run a promotion',
    subCopy: (
      <>
        Join a promotional campaign.
        <br />
        Available for <strong>Zip Money</strong> , <strong>Zip Plus</strong> and{' '}
        <strong>Zip Pay</strong>.
      </>
    ),
    selected: false,
    details: {
      label: 'Add product and promotion details*',
      text: '',
    },
    requiredErrorMessage: 'Product and promotion details are required',
  },
  {
    id: 4,
    title: 'I am not sure',
    subCopy: <>I would like to speak to someone about optimising my account.</>,
    selected: false,
    details: {
      label: 'Tell us a bit more*',
      text: '',
    },
    requiredErrorMessage: 'More details are required',
  },
];
